import * as React from 'react'

function SvgTw(props) {
	return (
		<svg viewBox="-60 -40 240 160" width="1em" height="1em" {...props}>
			<rect x={-60} y={-40} width="100%" height="100%" fill="#fe0000" />
			<rect x={-60} y={-40} width="50%" height="50%" fill="#000095" />
			<path id="tw_svg__a" d="M8 0L0 30-8 0l8-30M0 8l30-8L0-8l-30 8" fill="#fff" />
			<use xlinkHref="#tw_svg__a" transform="rotate(30)" />
			<use xlinkHref="#tw_svg__a" transform="rotate(60)" />
			<circle r={17} fill="#000095" />
			<circle r={15} fill="#fff" />
		</svg>
	)
}

export default SvgTw
